import type { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import {
    OrthodontistCreateFieldGrid,
    type OrthodontistCreateFieldGridProps
} from '../create/OrthodontistCreateFieldGrid';

interface OrthodontistGroupCardProps extends OrthodontistCreateFieldGridProps {
    icon: typeof BuildingOffice2Icon;
    label: string;
}

export function OrthodontistGroupCard({
    icon: Icon,
    label,
    ...gridProps
}: OrthodontistGroupCardProps) {
    return (
        <div className="bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.06)] overflow-hidden shrink-0">
            <div className="border-b border-gray-100 flex items-center gap-2.5 px-5 h-12">
                <Icon className="h-4 w-4 text-gray-400" />
                <h3 className="text-[13px] font-bold text-gray-800">{label}</h3>
                <span className="text-[12px] text-gray-400">{gridProps.fields.length} fields</span>
            </div>
            <OrthodontistCreateFieldGrid {...gridProps} />
        </div>
    );
}
